
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CitiesMasterDialog extends Serenity.EntityDialog<CitiesMasterRow, any> {
        protected getFormKey() { return CitiesMasterForm.formKey; }
        protected getIdProperty() { return CitiesMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CitiesMasterRow.localTextPrefix; }
        protected getNameProperty() { return CitiesMasterRow.nameProperty; }
        protected getService() { return CitiesMasterService.baseUrl; }
        protected getInsertPermission() { return CitiesMasterRow.insertPermission; }
        protected getUpdatePermission() { return CitiesMasterRow.updatePermission; }
        protected getDeletePermission() { return CitiesMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        protected form = new CitiesMasterForm(this.idPrefix);

        constructor() {
            super();
           
        }

        
    }
}